/**
 * Downstream Report Bar Component - This Incldues the Bar Component Configuration for Downstream report
 */
import React from 'react';
import { ResponsiveBar } from '@nivo/bar'
import { REPORT_RIGHTS, isReportRightApplicable, DEACTIVATE_ACCOUNT_COLOR } from '../reportRights';

const allKeys = REPORT_RIGHTS.map(right => right.abbr);
const assignColor = (bar) => {
    const colors = {
        AWL: "#c41a1a",
        DA: DEACTIVATE_ACCOUNT_COLOR,
        ISR: "#b96ee7",
        RWL: "#d0b870",
        RTC: "#70ad47",
        RTD: "#5b9bd5",
        RTK: "#ffc000",
        RTO: "#43682b",
        RTT: "#ee553e",
        TVLA: "#1b3a6b",
        UFV: "#137ade",
    }

    return colors[bar.id]
}

const getTooltip = (data) => {
    return (
        <div style={{
            background: 'white',
            padding: '9px 12px',
            border: '1px solid #ccc',
            borderRadius: '4px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
            fontSize: '14px',
            fontWeight: '500',
            color: '#333'
        }}>
            <div style={{ marginBottom: '4px', fontWeight: '600', color: assignColor(data) }}>
                {data.id}
            </div>
            <div>
                Count: <strong>{data.value}</strong>
            </div>
        </div>
    )
}

const checkIsEmpty =(data, keys)=>{
      let isExists = true;
data.forEach((item)=>{
    keys.forEach(innerItem =>{
       if(item[innerItem] > 0){
        isExists = false;

       }
    })
})

      return isExists
}

const DownstreamBarGraph = ({ data, driverOnly, requestor = 'All' }) => {
    const keys = allKeys.filter(key => isReportRightApplicable(key, driverOnly ? 'Driver' : requestor));
    return (
        <>{checkIsEmpty(data, keys) ?
        <div style={{display:'flex', justifyContent:"center", alignItems:"center", height:"400px"}}>No records available to display</div>:
    <ResponsiveBar
        data={data}
        keys={keys}
        layout="horizontal"
        indexBy="name"
        margin={{ top: 50, right: 100, bottom: 50, left: 180 }}
        padding={0.3}
        colors={assignColor}
        borderColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
        labelSkipWidth={12}
        labelSkipHeight={12}
        tooltip={getTooltip}
        axisBottom={{
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            // legend: 'Requests',
            legendPosition: 'middle',
            legendOffset: 32
        }}
        labelTextColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
        legends={[
            {
                dataFrom: 'keys',
                anchor: 'bottom-right',
                direction: 'column',
                justify: false,
                translateX: 120,
                translateY: 0,
                itemsSpacing: 2,
                itemWidth: 100,
                itemHeight: 20,
                itemDirection: 'left-to-right',
                itemOpacity: 0.85,
                symbolSize: 20,
                effects: [
                    {
                        on: 'hover',
                        style: {
                            itemOpacity: 1
                        }
                    }
                ]
            }
        ]}
        animate={true}
        motionStiffness={90}
        motionDamping={15}
        enableGridX={true}
        enableGridY={false}
    />}
    </>
)
}

export default DownstreamBarGraph;
